






import { Component, Vue } from 'vue-property-decorator'

@Component({
  computed: {
    overlayClasses(): string {
      return this.$store.state.loading ? '' : 'hidden'
    },
  },
})
export default class Overlay extends Vue {
}
